import { render, staticRenderFns } from "./TerminManager.vue?vue&type=template&id=009b8eab&scoped=true"
import script from "./TerminManager.vue?vue&type=script&lang=js"
export * from "./TerminManager.vue?vue&type=script&lang=js"
import style0 from "./TerminManager.vue?vue&type=style&index=0&id=009b8eab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009b8eab",
  null
  
)

export default component.exports